//firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBc7QSP6xGtyj3O-pG4JozNuwqX2I_buxQ",
  authDomain: "dental-clinic-1a8c1.firebaseapp.com",
  projectId: "dental-clinic-1a8c1",
  storageBucket: "dental-clinic-1a8c1.appspot.com",
  messagingSenderId: "508973081292",
  appId: "1:508973081292:web:8fc07b52f8736590365869"
};

export default firebaseConfig;
